export const locale = {
  lang: 'tr',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      Language: 'Dil',
      AppName: 'Uygulama Adı',
      Add: 'Ekle',
      Edit: 'Düzenle',
      Delete: 'Sil',
      Search: 'Ara',
      SaveChanges: 'Değişiklikleri Kaydet',
      Cancel: 'İptal',
      Home: 'Ana Sayfa',
      Zar3: 'Zar3',
      Settings: 'Ayarlar',
      Logout: 'Çıkış Yap',
      Profile: 'Profil',
      Username: 'Kullanıcı Adı',
      Password: 'Şifre',
      RememberMe: 'Beni Hatırla',
      ForgotPassword: 'Şifremi Unuttum',
      Login: 'Giriş Yap',
      Register: 'Kaydol',
      Dashboard: 'Gösterge Paneli',
      AdminPanel: 'Yönetici Paneli',
      Users: 'Kullanıcılar',
      Roles: 'Roller',
      Permissions: 'İzinler',
      Reports: 'Raporlar',
      Notifications: 'Bildirimler',
      Messages: 'Mesajlar',
      Help: 'Yardım',
      AboutUs: 'Hakkımızda',
      ContactUs: 'İletişim',
      TermsOfService: 'Hizmet Şartları',
      PrivacyPolicy: 'Gizlilik Politikası',
      LanguageSettings: 'Dil Ayarları',
      ThemeSettings: 'Tema Ayarları',
      DarkMode: 'Karanlık Mod',
      LightMode: 'Aydınlık Mod',
      SystemDefault: 'Sistem Varsayılanı',
      UserManagement: 'Kullanıcı Yönetimi',
      AddUser: 'Kullanıcı Ekle',
      EditUser: 'Kullanıcıyı Düzenle',
      DeleteUser: 'Kullanıcıyı Sil',
      RoleManagement: 'Rol Yönetimi',
      AddRole: 'Rol Ekle',
      EditRole: 'Rolü Düzenle',
      DeleteRole: 'Rolü Sil',
      PermissionManagement: 'İzin Yönetimi',
      AddPermission: 'İzin Ekle',
      EditPermission: 'İzni Düzenle',
      DeletePermission: 'İzni Sil',
      ViewReports: 'Raporları Görüntüle',
      GenerateReport: 'Rapor Oluştur',
      ExportReport: 'Raporu Dışa Aktar',
      ViewNotifications: 'Bildirimleri Görüntüle',
      MarkAsRead: 'Okundu Olarak İşaretle',
      DeleteNotification: 'Bildirimi Sil',
      SendMessage: 'Mesaj Gönder',
      ViewMessage: 'Mesajı Görüntüle',
      DeleteMessage: 'Mesajı Sil',
      SearchMessages: 'Mesajları Ara',
      ContactSupport: 'Destek ile İletişime Geç',
      FAQ: 'SSS',
      SubmitTicket: 'Talep Gönder',
      ChatWithUs: 'Bizimle Sohbet Et',
      EducationalLevel: 'Eğitim Düzeyi',
      WorkLocation: 'Çalışma Yeri',
      JobTitle: 'İş Unvanı',
      AddExam: 'Sınav Ekle',
      StageType: 'Aşama Türü',
      StageName: 'Aşama Adı',
      RolesManagement: 'Rol Yönetimi',
      BackendRole: 'Arka Uç Rolü',
      RoleName: 'Rol Adı',
      BackendUsersManagement: 'Arka Uç Kullanıcı Yönetimi',
      FullName: 'Tam Ad',
      ArabicFullName: 'Tam Arapça Ad',
      FullEnglishName: 'Tam İngilizce Ad',
      Gender: 'Cinsiyet',
      BirthDate: 'Doğum Tarihi',
      BirthCountry: 'Doğum Ülkesi',
      Specialization: 'Uzmanlık',
      Course: 'Kurs',
      ManagingStageDetails: 'Aşama Detaylarını Yönet',
      StartSavingPage: 'Kaydedilecek Sayfa',
      EndSavingPage: 'Kaydedilecek Sayfa',
      StartReviewPage: 'İncelenecek Sayfa',
      EndReviewPage: 'İncelenecek Sayfa',
      SavePage: 'Kaydet',
      ReviewPage: 'Gözden Geçir',
      Student: 'Öğrenci',
      Students: 'Öğrenciler',
      FirstPart: 'Birinci Bölüm',
      LessonSaving: 'Ders Kaydetme',
      LessonReview: 'Ders Gözden Geçirme',
      CourseName: 'Kurs Adı',
      LessonOrder: 'Ders Sırası',
      AddQuranKaremStage: 'Kuran-ı Kerim Aşaması Ekle',
      QuranKaremStage: 'Kuran-ı Kerim Aşaması',
      Management: 'Yönetim',
      Save: 'Kaydet',
      QuranKaremCourseManagement: 'Kuran-ı Kerim Kurs Yönetimi',
      QuranKaremStageManagement: 'Aşama Yönetimi',
      TotalSavingPageCount: 'Toplam Sayfa Sayısı',
      TotalReviewPageCount: 'Toplam İncelenecek Sayfa Sayısı',
      FromSavingPage: 'Kaydedilecek Sayfa',
      ToSavingPage: 'Kaydedilecek Sayfa',
      FromReviewPage: 'İncelenecek Sayfa',
      ToReviewPage: 'İncelenecek Sayfa',
      Family: 'Aile',
      QuranKaremExamQuestionName: 'Soru Adı',
      AnswerName: 'Cevap Adı',
      ProgramManagement: 'Program Yönetimi',
      AddTeacher: 'Öğretmen Ekle',
      TeacherFullName: 'Öğretmen Tam Adı',
      TeacherProfile: 'Öğretmen Profili',
      IsOnline: 'Çevrimiçi mi?',
      Teacher: 'Öğretmen',
      QuranKaremTeacher: 'Kuran-ı Kerim Öğretmeni',
      ParentsCount: 'Veli Sayısı',
      AddExamQuestion: 'Soru Ekle',
      QuranKaremExamQuestions: 'Kuran-ı Kerim Sınav Soruları',
      TotalCourseQuestionsCount: 'Toplam Soru Sayısı',
      ManagementCourseLevelType: 'Kurs Seviye Türünü Yönet',
      Saving: 'Kaydetme',
      CourseExamsManagement: 'Kurs Sınav Yönetimi',
      QuranKaremCourseStageManagement: 'Kurs Aşama Yönetimi',
      AddFamily: 'Aile Ekle',
      SaveQuranKaremStageDetails: 'Aşama Detaylarını Kaydet',
      QuranKaremTeacherManagement: 'Öğretmen Yönetimi',
      BranchesManagement: 'Şube Yönetimi',
      AddQuranKaremLevel: 'Seviye Ekle',
      LessonInfoManagement: 'Ders Bilgilerini Yönet',
      TotalExamQuestionsCount: 'Toplam Soru Sayısı',
      EndPart: 'Bitiş Bölümü',
      HomeworkManagement: 'Ev Ödevi Yönetimi',
      FullNameEnglish: 'Tam İngilizce Ad',
      General: 'Genel',
      TeacherManagement: 'Öğretmen Yönetimi',
      CourseTeacherManagement: 'Kurs Öğretmen Yönetimi',
      CourseTeacher: 'Kurs Öğretmeni',
      CourseLevelTypeManagement: 'Seviye Türü Yönetimi',
      CourseTeachersManagement: 'Kurs Öğretmen Yönetimi',
      StudentManagement: 'Öğrenci Yönetimi',
      GeneralExam: 'Genel Sınav',
      Reviewing: 'İnceleme',
      SavingPage: 'Kaydetme Sayfası',
      StageDetails: 'Aşama Detayları',
      ManagementStages: 'Aşama Yönetimi',
      ReviewingStages: 'İnceleme Aşamaları',
      ExamName: 'Sınav Adı',
      SavingStage: 'Aşama Kaydetme',
      AddQuranKaremStageDetail: 'Aşama Detayı Ekle',
      SavingStages: 'Aşamaları Kaydet',
      AddQuranKaremCourseManagement: 'Kurs Yönetimi Ekle',
      CourseManagement: 'Kurs Yönetimi',
      AddCourseManagement: 'Kurs Yönetimi Ekle',
      QuranKaremManagement: 'Kuran-ı Kerim Yönetimi',
      TotalStudentsCount: 'Toplam Öğrenci Sayısı',
      Keywords: 'Anahtar Kelimeler',
      Next: 'Sonraki',
      Previous: 'Önceki',
      TotalQuranKaremCourseCount: 'Kuran-ı Kerim Kurs Sayısı',
      HomeWorkAttachment: 'Ekli Dosyalar',
      IsVisibleToApply: 'Başvuru Görünürlüğü',
      DueDate: 'Son Başvuru Tarihi',
      ReadMore: 'Devamını Oku',
      FullText: 'Tam Metin',
      BranchesCount: 'Merkez Sayısı',
      CoursesCount: 'Kurs Sayısı',
      UpdatePassword: 'Şifre Güncelle',
      PageName: 'Sayfa Adı',
      TeacherReports: 'Öğretmen Raporları',
      StudentReports: 'Öğrenci Raporları',
      GeneralReports: 'Genel Raporlar',
      BranchesReports: 'Merkez Raporları',
      CourseReports: 'Kurs Raporları',
      LevelStageReports: 'Kategori ve Seviye Raporları',
      Admin: 'Yönetici',
      CategoryType: 'Kategori Türü',
      PublicNews: 'Genel Haberler',
      CategoryNews: 'Haber Kategorileri',
      ShortText: 'Kısa Metin',
      ExamResult: 'Sınav Sonuçları',
      SetType: 'Tür Seç',
      AddQuranKaremCourse: 'Kurs',
      MeetingUrl: 'Toplantı URL',
      StudentLessons: 'Öğrenci Dersleri',
      StudnetLesson: 'Öğrenci Dersleri',
      AttachmentUrl: 'Video URL',
      LessonName: 'Ders Adı',
      QuranKaremLevelType: 'Tür',
      ToAssignment: 'Ders Ödevine',
      FromAssignment: 'Ders Ödevinden',
      Url: 'URL',
      AddAttachment: 'Ekler Ekle',
      IsOrphan: 'Öğrenci yetim mi',
      ExpectedTotalPageSaving: 'Ezberlenecek Sayfa Sayısı',
      ExpectedTotalPageReview: 'Gözden Geçirilecek Sayfa Sayısı',
      ExamPoint: 'Sınav Puanı',
      RequiredCount: 'Zorunlu Soru Sayısı',
      SetDetail: 'Detay Belirle',
      SelectExam: 'Sınav Seç',
      QuranKaremExamSetTeacherExam: 'Öğrencilere Sınav ve Öğretmen Ata',
      TotalPage: 'Toplam Sayfalar',
      AlmaherMangement: 'Al-Maher Program Yönetimi',
      ManagingFliexibleSetting: 'Esnek Ayar Yönetimi',
      AddQuestion: 'Soru Ekle',
      WrongPoint: 'Yanlış Puan',
      YouTubeUrl: 'YouTube URL',
      QuranKaremCourseName: 'Kuran-ı Kerim Kurs Adı',
      QuranKaremStageName: 'Aşama Adı',
      QuranKaremLevelName: 'Seviye Adı',
      CourseExamName: 'Kurs Adı',
      AppledCourseExam: 'Temel Kurs Sınavı Başvuruları',
      AppledQuranKaremExam: 'Kuran-ı Kerim Sınavı Başvuruları',
      CourseStudents: 'Kurs Öğrencileri',
      SelectStudent: 'Öğrenci Seç',
      SelectTeacher: 'Öğretmen Seç',
      Cv: 'CV',
      ManagingBackPermissions: 'Backend İzin Yönetimi',
      ManagingFrontPermissions: 'Frontend İzin Yönetimi',
      SetLevel: 'Seviye Seç',
      Attachments: 'Ekler',
      QuranCourseName: 'Kurs Adı',
      AddStageDetails: 'Aşama Detayları Ekle',
      StagesDetails: 'Aşama Detayları',
      StudentsCount: 'Öğrenci Sayısı',
      QuranKaremCourses: 'Kuran-ı Kerim Kursları',
      QuranKaremCoursesMangments: 'Kurs Yönetimi',
      TotalCourseCount: 'Toplam Kurs Sayısı',
      TotalLessonCount: 'Toplam Ders Sayısı',
      TotalHomeWorkApplyedCount: 'Öğrenci Ödev Başvuru Sayısı',
      TeachersCount: 'Öğretmen Sayısı',
      FamilyCount: 'Aile Sayısı',
      BranchiesCount: 'Merkez Sayısı',
      QuranKaremExamName: 'Sınav Adı',
      Point: 'Puanlar',
      Appreciation: 'Değerlendirme',
      ExamType: 'Sınav Türü',
      QuestionPoint: 'Soru Puanı',
      Question: 'Soru Metni',
      TotalPageNumber: 'Toplam Sayfalar',
      ExamSuperVisor: 'Sınav Gözetmeni',
      QuranKaremQuestions: 'Kuran-ı Kerim Sınav Soruları',
      CourseQuestions: 'Temel Kurs Soruları',
      CourseExams: 'Temel Kurs Sınavları',
      QuranKaremExam: 'Kuran-ı Kerim Sınavları',
      CreateQuranKaremExamQuestion: 'Kuran-ı Kerim Sınav Sorusu',
      CreateQuranKaremExam: 'Sınav Oluştur',
      Questions: 'Soruları Yönet',
      CourseExam: 'Kurs Sınavları',
      ApplyedCourseExam: 'Temel Kurs Sınavı Başvuruları',
      ApplyedQuranKaremExam: 'Sınav Başvuruları',
      Branch: 'Şube',
      Exams: 'Sınavları Yönet',
      Exam: 'Sınavlar',
      Report: 'Raporlar',
      Level: 'Seviye',
      New: 'Yeni',
      HomeWork: 'Ödevler',
      QuranKarem: 'Kuran-ı Kerim',
      Basic: 'Genel',
      AllUsers: 'Kullanıcılar',
      EndTime: 'Bitiş Zamanı',
      Homework: 'Ev Ödevi',
      Clone: 'Kopyala',
      InsertCsv: 'CSV Dosyası Ekle',
      TeacherName: 'Öğretmen Adı',
      StudentName: 'Öğrenci Adı',
      StudnetName: 'Öğrenci Adı',
      CourseTeachers: 'Kurs Öğretmenleri',
      AddLesson: 'Ders Ekle',
      CourseStudent: 'Kurs Öğrencisi',
      QuranKaremStagee: 'Kuran-ı Kerim Aşaması',
      CourseLevelMangments: 'Kurs Seviye Yönetimi',
      AddStage: 'Aşama Ekle',
      FromPage: 'Sayfadan',
      AddLevelToCourse: 'Kursa Seviye Ekle',
      LevelStages: 'Seviye Aşamaları',
      QuranKaremLevel: 'Kuran-ı Kerim Seviyesi',
      ToPage: 'Sayfaya',
      Order: 'Sıra',
      SelectQuestion: 'Soru Seç',
      Stage: 'Aşama',
      IsHaveExam: 'Sınav Var mı',
      StartTime: 'Başlangıç Zamanı',
      FromPageSaving: 'Ezberleme Sayfasından',
      ToPageSaving: 'Ezberleme Sayfasına',
      FromPageReview: 'Gözden Geçirme Sayfasından',
      ToPageReview: 'Gözden Geçirme Sayfasına',
      ProgramsMangments: 'Program Yönetimi',
      ProgrameType: 'Program Türü',
      LessonType: 'Ders Türü',
      Content: 'İçerik',
      FromPart: 'Bölümden',
      FromLesson: 'Dersten',
      TotalPageLesson: 'Toplam Dersler',
      ManagingLessonInfo: 'Ders Bilgilerini Yönet',
      LessonsInfo: 'Ders Bilgileri',
      ManagingLessonType: 'Ders Türünü Yönet',
      ToPart: 'Bölüme',
      ToLesson: 'Derse',
      PlaceOfResidence: 'İkamet Yeri',
      CertificateAttachment: 'Sertifika Eki',
      Nationality: 'Uyruk',
      FatherName: 'Baba Adı',
      MotherName: 'Anne Adı',
      UserIdNumber: 'Kimlik Numarası',
      PlaceOfResidenc: 'İkamet Yeri',
      CertificateName: 'Sertifika Adı',
      BestDayInThisYear: 'Bu Yılın En İyi Günü',
      Birthday: 'Doğum Tarihi',
      News: 'Haberler',
      BranchName: 'Merkez Adı',
      TrainingName: 'Eğitim Adı',
      StartDate: 'Başlangıç Tarihi',
      EndDate: 'Bitiş Tarihi',
      MaxStudentCount: 'Maksimum Öğrenci Sayısı',
      Price: 'Fiyat',
      IsActive: 'Aktif',
      CourseReport: 'Kurs Hasadı',
      Type: 'Kurs Türü',
      AddStudent: 'Öğrenci Ekle',
      AddLevel: 'Seviye Ekle',
      TotalPageSavedCount: 'Toplam Ezberlenen Sayfa Sayısı',
      TotalPartSavedCount: 'Toplam Ezberlenen Bölüm Sayısı',
      LessonMangments: 'Ders Yönetimi',
      StagesMangments: 'Aşama Yönetimi',
      LevelsMangments: 'Kategori ve Seviye Yönetimi',
      CoursesMangments: 'Kurs Yönetimi',
      CoursMangments: 'Kurs Yönetimi',
      TeacherCount: 'Öğretmen Sayısı',
      LogoImg: 'Logo Resmi',
      Courses: 'Müfredat ve Kurslar',
      AddressInMap: 'Haritadaki Adres',
      ManagerUserId: 'Merkez Müdürü',
      Lessons: 'Dersler',
      ManagingPositions: 'Pozisyon Yönetimi',
      Activities: 'Aktiviteler',
      ManagingCourses: 'Kurs Yönetimi',
      ManagingLesson: 'Ders Yönetimi',
      Branches: 'Şubeler',
      Admins: 'Yöneticiler',
      Location: 'Konum',
      CallUs: 'Bizi Arayın',
      Send: 'Gönder',
      FollowUs: 'Bizi Takip Edin',
      Newsletter: 'E-posta Listeleri',
      YourEmailAddress: 'E-posta Adresiniz',
      ToGetNews: 'Tüm son haberlerimizi alın',
      UsefulLink: 'Hızlı Bağlantılar',
      VideoUrl: 'Video URL',
      Subscribe: 'Abone Ol',
      KeyWord: 'Anahtar Kelime',
      Visionforummah: 'Bir Millet İçin Topluluk',
      ShortDesc: 'Kısa Açıklama',
      Faq: 'Sık Sorulan Sorular',
      BasicPages: 'Temel Sayfalar',
      BasicPage: 'Temel Sayfa',
      MailingList: 'E-posta Listesi',
      Contact: 'Bize Ulaşın',
      Activity: 'Merkez Aktiviteleri',
      About: 'Hakkımızda',
      ReadAll: 'Daha Fazla',
      BadDayInThisYear: 'Bu Yılın En Kötü Günü',
      BadDay: 'Kötü Gün',
      BestDay: 'En İyi Gün',
      BestDiffValue: 'En İyi Fark Değeri',
      BadDiffValue: 'En Kötü Fark Değeri',
      BestTipValue: 'En İyi İpucu',
      BadTipValue: 'En Kötü İpucu',
      BestBarValue: 'En İyi Çubuk Değeri',
      BadBarValue: 'En Kötü Çubuk Değeri',
      Today: 'Bugün',
      Daily: 'Günlük',
      Weekly: 'Haftalık',
      Monthly: 'Aylık',
      Yearly: 'Yıllık',
      AutoChooseSerialNumber: 'Seri Numarasını Otomatik Seç',
      SerailNumber: 'Seri Numarası',
      MinimumQuantity: 'Minimum Miktar',
      Quantity: 'Miktar',
      CrateionDate: 'Oluşturma Tarihi',
      GoToDetails: 'Detaylara Git',
      QuantityInStock: 'Stoktaki Miktar',
      Count: 'Sayı',
      Tax: 'Vergi',
      ProductName: 'Ürün Adı',
      Invoice: 'Fatura',
      AddProductToInvoice: 'Faturaya Ürün Ekle',
      Used: 'Kullanılmış',
      NotUsed: 'Kullanılmamış',
      SerialNumber: 'Seri Numarası',
      Status: 'Durum',
      CreationDate: 'Oluşturma Tarihi',
      ChooseFile: 'Dosya Seç',
      UploadFile: 'Dosya Yükle',
      DownloadSerialNumberFile: 'Seri Numarası Dosyasını İndir',
      ProblemDetail: 'Sorun Detayları',
      AddEditCommonMistakes: 'Ortak Hataları Ekle/Düzenle',
      Solution: 'Çözüm',
      Problem: 'Sorun',
      MaterialType: 'Malzeme Türü',
      RemainedWarantyDays: 'Kalan Garanti Günleri',
      Catalog: 'Katalog',
      Done: 'Tamamlandı',
      Required: 'Gerekli',
      NameLocale: 'Yerel Dildeki Ad',
      SellingPrice: 'Satış Fiyatı',
      Cost: 'Maliyet',
      VendorInformation: 'Satıcı Bilgileri',
      AddNewVendors: 'Yeni Satıcı Ekle',
      Vendors: 'Satıcılar',
      CommonMistakes: 'Ortak Hatalar',
      AddSerialNumbers: 'Seri Numaraları Ekle',
      InsertSerialNumber: 'Seri Numarası Ekle',
      FullAddress: 'Tam Adres',
      Value: 'Değer',
      ChannelName: 'Kanal Adı',
      FullAdress: 'Tam Adres',
      Latitude: 'Enlem',
      Longitude: 'Boylam',
      State: 'Durum',
      AddNewContact: 'Yeni İletişim Ekle',
      AddNewAddress: 'Yeni Adres Ekle',
      CustomerInvoice: 'Müşteri Faturası',
      Contacts: 'İletişimler',
      City: 'Şehir',
      Address: 'Adres',
      ACTIONS: 'İşlemler',
      CustomerCategory: 'Müşteri Kategorisi',
      FirstName: 'Ad',
      CustomerNumber: 'Müşteri Numarası',
      EditCustomerInformation: 'Müşteri Bilgilerini Düzenle',
      AddNewCustomerInformation: 'Yeni Müşteri Bilgileri Ekle',
      LastName: 'Soyad',
      AddressCount: 'Adres Sayısı',
      ContactCount: 'İletişim Sayısı',
      AddNewCustomer: 'Yeni Müşteri Ekle',
      PhoneNumber: 'Telefon Numarası',
      CustomerLastName: 'Müşteri Soyadı',
      AddNewInvoice: 'Yeni Fatura Ekle',
      SequenceNumber: 'Sıra Numarası',
      CustomerName: 'Müşteri Adı',
      TotalAmount: 'Toplam Tutar',
      RemainingAmount: 'Kalan Tutar',
      Note: 'Not',
      NumberOfOrders: 'Sipariş Sayısı',
      AddProduct: 'Ürün Ekle',
      CustomerInformation: 'Müşteri Bilgileri',
      ProductNumber: 'Ürün Numarası',
      NameAr: 'Arapça Ad',
      Description: 'Açıklama',
      Warranty: 'Garanti',
      Barcode: 'Barkod',
      Notes: 'Notlar',
      Available: 'Mevcut',
      Unavailable: 'Mevcut Değil',
      AddCatalog: 'Katalog Ekle',
      AddImage: 'Resim Ekle',
      SearchbySerialNumber: 'Seri Numarasına Göre Ara',
      User: 'Kullanıcı',
      Customers: 'Müşteriler',
      Chat: 'Sohbet',
      AddService: 'Hizmet Ekle',
      SendNotification: 'Bildirim Gönder',
      UsersMobile: 'Kullanıcı Cep Telefonu Numaraları',
      AddSubSection: 'Alt Bölüm Ekle',
      DiscountValue: 'İndirim Değeri',
      RegisteredDate: 'Kayıt Tarihi',
      Email: 'E-posta',
      DateBirth: 'Doğum Tarihi',
      Phone: 'Telefon',
      Product: 'Ürün',
      UserName: 'Kullanıcı Adı',
      Rate: 'Değerlendirme',
      FileType: 'Dosya Türü',
      IsVisible: 'Başvuru için Görünür',
      comments: 'Yorumlar',
      OrderCode: 'Sipariş Kodu',
      Total: 'Toplam',
      Date: 'Tarih',
      Section: 'Bölüm',
      SelectUser: 'Kullanıcı Seç',
      SubSection: 'Alt Bölüm',
      Time: 'Zaman',
      Services: 'Hizmetler',
      SubCategory: 'Alt Kategori',
      Comments: 'Yorumlar',
      Service: 'Hizmet',
      Img1: 'Resim 1',
      Img2: 'Resim 2',
      Img3: 'Resim 3',
      Img4: 'Resim 4',
      Category: 'Kategori',
      Name: 'Ad',
      AddSubCategory: 'Alt Kategori Ekle',
      Image: 'Resim',
      Sliders: 'Kaydırıcılar',
      Invoices: 'Faturalar',
      Actions: 'İşlemler',
      Text: 'Metin',
      Title: 'Başlık',
      Sections: 'Bölümler',
      Categories: 'Kategoriler',
      Offers: 'Teklifler',
      Teams: 'Takımlar',
      Clinic: 'Klinik',
      Orders: 'Siparişler',
      Products: 'Ürünler',
      Dates: 'Tarihler',
      AreYouSure: 'Emin misiniz',
      YouWillNotAble: 'Bu hayali dosyayı kurtaramayacaksınız!',
      Warning: 'Uyarı',
      YesDelete: 'Evet, sil!',
      NoKeep: 'Hayır, sakla',
      Deleted: 'Silindi!',
      YourFileDeleted: 'Hayali dosyanız silindi!',
      Cancelled: 'İptal edildi',
      YourImaginarySafe: 'Hayali dosyanız güvende',
      SomethingWentWrong: 'Bir şeyler yanlış gitti',
      RemovedSuccessfully: 'Başarıyla kaldırıldı',
      UpdatedSuccessfully: 'Başarıyla güncellendi',
      AddedSuccessfully: 'Başarıyla eklendi',
      DASHBOARD: 'Gösterge Paneli',
      Back: 'Geri',
      Reset: 'Sıfırla',
      Create: 'Oluştur',
      Correct: 'Doğru',
      IsRequired: 'Gerekli',
      ButThisAlreadyAdded: 'Ama bu zaten eklenmiş',
      IsDeleting: 'Siliniyor...',
      DeletePermanently: 'Bu kaydı kalıcı olarak silmek istediğinizden emin misiniz?',
      AddNew: 'Yeni Ekle'
    }
  },
}; 